import React from 'react';
import cx from 'classnames';

import styles from './SpinningIcon.module.scss';

export type SpinningIconProps = {
  className?: string;
};

const SpinningIcon: React.FC<SpinningIconProps> = ({ className }) => {
  return (
    <div className={cx(styles.spinningIcon, className)}>
      <div className={styles.loader}></div>
    </div>
  );
};

export default SpinningIcon;
